import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { TypePageData } from '../_models/TypePage';
import useStyles from './styles';

interface Props {
  content: TypePageData;
}

const MobileHeader = ({ content }: Props) => {
  const { title, mobileTitle, background, icon, Icon } = content;
  const classes = useStyles({ background });

  return (
    <Box component="section" className={classes.wrapper}>
      <Grid container item xs={12} className={classes.container}>
        <Grid container item xs={9} className={classes.textContainer}>
          <Typography variant="h1">
            {!!mobileTitle ? mobileTitle : title}
          </Typography>
        </Grid>
        <Grid container item xs={3} className={classes.iconContainer}>
          {!!icon ? (
            <img src={icon} alt={title} draggable="false" />
          ) : (
            !!Icon && <Icon />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default MobileHeader;
